import { OPERATIONS_CASE_STUDY } from '@/data/operations';
import { ServiceCaseStudy } from '../service/ServiceCaseStudy';

export const CaseStudy = () => (
  <ServiceCaseStudy
    data={OPERATIONS_CASE_STUDY}
    accent="#FFB800"
    accentDark="#9C7400"
    index="05"
    testidPrefix="operations"
  />
);
